import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLanguageStore } from "../store/language";


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageToggleButtonC',
  setup(__props) {

const i18n = useI18n();
const languageStore = useLanguageStore();

const currentLanguage = computed(() => languageStore.currentLanguage as string);

const toggleLanguage = () => {
  const newLanguage = currentLanguage.value === "en" ? "es" : "en";
  languageStore.setCurrentLanguage(newLanguage);
  i18n.locale.value = newLanguage;
  localStorage.setItem("locale", newLanguage);
  document.documentElement.setAttribute("lang", newLanguage);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: toggleLanguage,
    class: "language-toggle-button",
    title: 
      currentLanguage.value === 'en' ? 'Switch to Español' : 'Cambiar a English'
    
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon is-small" }, [
      _createElementVNode("i", { class: "fas fa-language" })
    ], -1)),
    _createElementVNode("span", null, _toDisplayString(currentLanguage.value === "en" ? "ES" : "EN"), 1)
  ], 8, _hoisted_1))
}
}

})